import { render, staticRenderFns } from "./LoanCollateralAssetImmovableFieldsDisplay.vue?vue&type=template&id=e14f5aee&scoped=true&lang=pug&"
import script from "./LoanCollateralAssetImmovableFieldsDisplay.vue?vue&type=script&lang=js&"
export * from "./LoanCollateralAssetImmovableFieldsDisplay.vue?vue&type=script&lang=js&"
import style0 from "./LoanCollateralAssetImmovableFieldsDisplay.vue?vue&type=style&index=0&id=e14f5aee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e14f5aee",
  null
  
)

/* custom blocks */
import block0 from "./LoanCollateralAssetImmovableFieldsDisplay.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports